import { Component } from '@angular/core';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'in2-geolocating-modal',
  templateUrl: './geolocating.modal.html',
  styleUrls: ['./geolocating.modal.scss'],
  standalone: false,
})
export class GeolocatingModal {
  public faMapMarkerAlt = faMapMarkerAlt;
}
